module.exports = __webpack_public_path__ + "img/home_icon_winspect@2x.70d0b256.png";